import { render, staticRenderFns } from "./LocalityUpdate.vue?vue&type=template&id=98d6aa7e&scoped=true&"
import script from "./LocalityUpdate.vue?vue&type=script&lang=js&"
export * from "./LocalityUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d6aa7e",
  null
  
)

export default component.exports